import React from 'react'
import { Avatar, Tooltip } from 'antd'
import { MdModeEdit } from 'react-icons/md';

const BtnEditUC = (props) => {
    const { handleEdit, disabled } = props;
    const isCanEdit = disabled !== true;
    return (
        <>
            {isCanEdit ?
                <Tooltip placement="topLeft" title="แก้ไข">
                    <Avatar
                        shape="square"
                        icon={<MdModeEdit className='icon-edit icon-form cursor-pointer' />}
                        className="m-1 cursor-pointer"
                        onClick={isCanEdit ? handleEdit : {}}
                    />
                </Tooltip>
                :
                <Avatar
                    shape="square"
                    icon={<MdModeEdit className='icon-edit icon-form' disabled={true} />}
                    className="m-1"
                />
            }

        </>
    )
}

export default BtnEditUC